export const SQUARE_METER = 'מ"ר';
export const SLIDER_TITLE = "גודל במ״ר";
